const SampleImportance = {
    primary: "primary",
    secondary: "secondary"
};

export default SampleImportance;